/* global playTimeApiUrl */
// import videojs from 'video.js'
// import 'videojs-vtt-thumbnails' // サムネイルプラグイン
// import 'videojs-contrib-quality-levels' // 画質選択プラグイン
// import 'videojs-hls-quality-selector' // 画質選択プラグイン
import isOS from './functions/_isOS.js' // OSの分類を windows/android/ios/mac/other で返す

import scrollLock from './functions/_scrollLock.js' // スクロールロック
import getCookie from './functions/_cookie-getCookie.js' // Cookie取得
import setCookie from './functions/_cookie-setCookie.js' // Cookie発行

import { Autoplay, Controller, EffectFade, Navigation, Pagination, Swiper } from 'swiper'
import isDevice from './functions/_isDevice.js'
Swiper.use([Autoplay, Controller, EffectFade, Navigation, Pagination]) // Swiper宣言

if (document.getElementsByClassName('js-video')[0]) {
  videoPlayer()
}

// ボタンをクリックしたらフォーカスを外す
window.addEventListener('click', function (e) {
  const item = e.target.closest('button')
  if (!item) {
    return
  }
  document.activeElement.blur()
})

function videoPlayer() {
  const deviceOS = isDeviceOS()

  const player = []

  const videoList = document.getElementsByClassName('js-video')
  let videoID = 0
  for (const videoItem of videoList) {
    // ラップ用クラスで覆う
    videoItem.outerHTML = '<div class="videoFrame">' + videoItem.outerHTML + '</div>'
  }
  for (const videoItem of videoList) {
    ++videoID
    videoItem.classList.add('video-' + videoID) // 識別用IDを付ける
    videoItem.dataset.videoId = videoID // 制御用IDを付ける

    // 動画を起動
    videoSetup(videoItem, videoID)
  }

  //   ####  #####  ######  ##   ##  #####
  //  ##     ##       ##    ##   ##  ##  ##
  //   ###   #####    ##    ##   ##  #####
  //     ##  ##       ##    ##   ##  ##
  //  ####   #####    ##     #####   ##

  function videoSetup(videoItem, videoID) {
    //  ##      ##  #####      ###    #####
    //  ##      ##  ##  ##    ## ##   ##  ##
    //  ##  ##  ##  #####    ##   ##  #####
    //  ##  ##  ##  ##  ##   #######  ##
    //   ###  ###   ##   ##  ##   ##  ##
    // 動画要素を決まったタグでラップする
    // 出力する操作ボタン
    let control = [
      { name: 'progressControl' },
      { name: 'playToggle' },
      { name: 'volumePanel', inline: true },
      { name: 'currentTimeDisplay' },
      { name: 'TimeDivider' },
      { name: 'durationDisplay' },
      { name: 'spacer' },
    ]
    if (deviceOS !== 'android') {
      // Android以外はピクチャーインピクチャーボタンを追加
      control.push({ name: 'pictureInPictureToggle' })
    }
    control.push({ name: 'FullscreenToggle' })

    player[videoID] = videojs(videoItem, {
      controls: true,
      fluid: true,
      autoplay: false,
      preload: 'none',
      controlBar: {
        children: control,
        // volumePanel: { inline: false },
      },
      html5: {
        hls: {
          overrideNative: !videojs.browser.IS_ANY_SAFARI,
        },
        nativeAudioTracks: false,
        nativeVideoTracks: false,
      },
    })

    const videoSrc = videoItem.dataset.video
    player[videoID].src(videoSrc)

    player[videoID].hlsQualitySelector({
      displayCurrentQuality: true,
    })

    player[videoID].addChild(CreateSkip(player, videoID), {})

    let chapter = videoItem.dataset.chapter
    if (chapter) {
      chapter = decodeURIComponent(chapter)
      addChapter(videoID, chapter)
    }
    //  ###    ###   #####   ####      ###    ##
    //  ## #  # ##  ##   ##  ##  ##   ## ##   ##
    //  ##  ##  ##  ##   ##  ##  ##  ##   ##  ##
    //  ##      ##  ##   ##  ##  ##  #######  ##
    //  ##      ##   #####   ####    ##   ##  ######
    // モーダル開閉時に動画を止める
    window.addEventListener('click', function (e) {
      // 指定のクラスを持つ
      if (e.target.classList.contains('js-modal-open') || e.target.classList.contains('js-modal-close')) {
        player[videoID].pause()
      }
    })

    //  ##   ##   #####   ##      ##   ##  ###    ###  #####
    //  ##   ##  ##   ##  ##      ##   ##  ## #  # ##  ##
    //  ##   ##  ##   ##  ##      ##   ##  ##  ##  ##  #####
    //   ## ##   ##   ##  ##      ##   ##  ##      ##  ##
    //    ###     #####   ######   #####   ##      ##  #####
    // 音量設定の記憶
    saveVolume()
    function saveVolume() {
      player[videoID].on(['loadstart'], function (e) {
        // 動画準備段階
        const videoVolume = getCookie('videoVolume') // Cookie取得
        const videoMuted = getCookie('videoMuted') // Cookie取得
        if (videoMuted === 'true') {
          player[videoID].muted(true) // ミュートを反映
          setCookie('videoMuted', videoMuted, 60 * 60 * 24 * 365, false) // 音量をCookieに格納
        }
        if (!isNaN(videoVolume)) {
          player[videoID].volume(parseFloat(videoVolume, 10)) // 音量を反映
          setCookie('videoVolume', videoVolume, 60 * 60 * 24 * 365, false) // 音量をCookieに格納
        }
      })
      player[videoID].on('volumechange', function () {
        // 音量変更時
        setCookie('videoMuted', player[videoID].muted(), 60 * 60 * 24 * 365, false) // ミュート状態をCookieに格納
        setCookie('videoVolume', player[videoID].volume(), 60 * 60 * 24 * 365, false) // 音量をCookieに格納
      })
    }

    //    ###    #####   ##
    //   ## ##   ##  ##  ##
    //  ##   ##  #####   ##
    //  #######  ##      ##
    //  ##   ##  ##      ##
    // 再生状況送信API
    let playDataTimer
    let lastSendTime = 0 // 最後に送信した時間
    let seekTime = 0 // シークした時間
    player[videoID].on(['seeked'], function (e) {
      // シークされた
      const time = Math.floor(player[videoID].currentTime()) // 小数切り捨てで再生時間取得
      const endTime = Math.floor(player[videoID].duration()) // 動画全体の再生時間
      // console.log(time)
      if (lastSendTime + 5 <= time && time !== endTime) {
        // 最後の時間より5秒以上進んでおり、かつ動画の末尾でない場合は送信予約
        seekTime = time - (time % 5)
      }
    })

    // 初回再生時限定の送信
    let firstSend = false
    player[videoID].on(['play'], function (e) {
      if (!firstSend) {
        playTimeAPI(videoItem.dataset.token, secToTime(seekTime), 0)
        firstSend = true
      }
    })

    player[videoID].on(['playing'], function (e) {
      // シーク時の再生予約を実行
      // videoTrayOn()
      if (seekTime !== 0) {
        // シーク時間が0秒以外なら実行
        playTimeAPI(videoItem.dataset.token, secToTime(seekTime), 0)
        lastSendTime = seekTime
      }
      seekTime = 0

      // 定期送信処理を実行
      playDataTimer = setInterval(function () {
        const time = Math.floor(player[videoID].currentTime()) // 小数切り捨てで再生時間取得
        // console.log(time)
        if (time !== 0 && time % 5 === 0 && time !== lastSendTime) {
          // 0秒以外の5の倍数秒、かつ最後に記録した時間と異なれば送信する
          playTimeAPI(videoItem.dataset.token, secToTime(time), 0)
          lastSendTime = time
        }
      }, 500)
    })

    player[videoID].on(['pause'], function (e) {
      // 停止したら送信を止める
      clearInterval(playDataTimer)
    })
    player[videoID].on(['ended'], function (e) {
      // videoTrayOn()
      // 動画が終わったら送信する
      clearInterval(playDataTimer)
      const time = Math.floor(player[videoID].currentTime()) // 小数切り捨てで再生時間取得
      playTimeAPI(videoItem.dataset.token, secToTime(time), 1)
    })

    //  #####  ##   ##  #####  ##     ##  ######
    //  ##     ##   ##  ##     ####   ##    ##
    //  #####  ##   ##  #####  ##  ## ##    ##
    //  ##      ## ##   ##     ##    ###    ##
    //  #####    ###    #####  ##     ##    ##
    player[videoID].on(['loadeddata'], function (e) {
      videoQualityButtonFix(videoID)
      const qua = document.querySelector('.video-' + videoID + ' .vjs-quality-selector')
      if (qua) {
        qua.classList.add('active')
      }

      barBtnSort(videoID) // ボタンを整列する
      popHoverMenu(videoItem) // 画面ホバーメニューを有効化する
      videoKey(videoID, videoItem) // キー操作を有効化する
      // videoDebug(e)
    })

    const playBtn = document.getElementById('hoverBtn-play--' + videoID)
    player[videoID].on(['play', 'pause', 'ended'], function (e) {
      // 再生ボタンのアイコンを差し替える

      if (playBtn) {
        if (player[videoID].paused()) {
          playBtn.classList.remove('play')
        } else {
          playBtn.classList.add('play')
        }
        if (player[videoID].ended()) {
          playBtn.classList.remove('play')
        }
      }
    })

    // 秒数skip
    player[videoID].getChild('controlBar').addChild(addRateBtn(player, videoID), {}, 6)

    // チャプター
    player[videoID].getChild('controlBar').addChild(addChapterBtn(player, videoID), {}, 6)

    // 画質表示
    player[videoID].getChild('controlBar').addChild(quality(player, videoID))

    // setVTT(videoID, videoItem.dataset.vtt)

    const vtt = videoItem.dataset.vtt
    if (vtt) {
      // console.log(vtt)

      const vttImg = path2dir(vtt)

      player[videoID].vttThumbnails({
        spriteUrl: vttImg,
        vttData: {
          url: vtt,
        },
      })
    }

    // パスからファイル名を抜いてディレクトリだけ抜き出す
    function path2dir(path) {
      const fileName = path.match('.+/(.+?)([?#;].*)?$')[1]
      const dir = path.replace(fileName, '')
      // console.log({ path })
      // console.log({ fileName })
      // console.log({ dir })
      return dir
    }

    barBtnSort(videoID) // ボタンを整列する

    window.addEventListener('resize', function (e) {
      barBtnSort(videoID) // ボタンを整列する
    })
  }

  //  #####  ##   ##  ##     ##   ####  ######  ##   #####   ##     ##
  //  ##     ##   ##  ####   ##  ##       ##    ##  ##   ##  ####   ##
  //  #####  ##   ##  ##  ## ##  ##       ##    ##  ##   ##  ##  ## ##
  //  ##     ##   ##  ##    ###  ##       ##    ##  ##   ##  ##    ###
  //  ##      #####   ##     ##   ####    ##    ##   #####   ##     ##
  function isDeviceOS() {
    const ua = navigator.userAgent.toLowerCase()
    if (ua.indexOf('iphone') > -1) {
      // iPhone
      return 'ios'
    }
    if (ua.indexOf('ipad') > -1) {
      // iPad
      return 'ios'
    }
    if (ua.indexOf('android') > -1 && ua.indexOf('mobile') > -1) {
      // Android
      return 'android'
    }
    if (ua.indexOf('android') > -1 && ua.indexOf('mobile') === -1) {
      // Android Tablet
      return 'android'
    }
    return 'pc'
  }

  //    ###    #####   ##            ######  ##  ###    ###  #####
  //   ## ##   ##  ##  ##              ##    ##  ## #  # ##  ##
  //  ##   ##  #####   ##  ########    ##    ##  ##  ##  ##  #####
  //  #######  ##      ##              ##    ##  ##      ##  ##
  //  ##   ##  ##      ##              ##    ##  ##      ##  #####

  function playTimeAPI(token, time, finish = 0) {
    // Ajaxで再生情報を送信する

    // console.log(time)

    let ajax = new XMLHttpRequest() // Ajaxリクエスト

    ajax.open('get', playTimeApiUrl + '?token=' + token + '&time=' + time + '&finish=' + finish, true) // GET/POST, URL, 非同期処理

    ajax.setRequestHeader('X-Requested-With', 'XMLHttpRequest') // Ajaxでのアクセスと明示するリクエストヘッダー

    ajax.responseType = 'document' // 取得タイプ document text json
    ajax.timeout = 10000 // タイムアウト判定時間

    ajax.send() // GETリクエスト実行

    ajax.onload = function () {
      // アクセス成功
      if (ajax.status < 200 || ajax.status >= 400) {
        console.log('Error: Code ' + ajax.status) // エラー
      }
    }
    ajax.ontimeout = function (e) {
      // タイムアウト
    }
    ajax.onerror = function () {
      // Ajax処理失敗
    }
    ajax.onloadend = function () {
      // 受信成否に関わらず実行
      ajax = null
    }
  }

  //   ####  #####   ####            ######  ##  ###    ###  #####
  //  ##     ##     ##                 ##    ##  ## #  # ##  ##
  //   ###   #####  ##     ########    ##    ##  ##  ##  ##  #####
  //     ##  ##     ##                 ##    ##  ##      ##  ##
  //  ####   #####   ####              ##    ##  ##      ##  #####

  /**
   * 総秒数を時:分:秒に変換
   * sec{int} 秒数
   */
  function secToTime(sec) {
    // 時間を求める
    const hour = Math.floor(sec / 3600)
    sec %= 3600

    // 分を求める
    const minute = Math.floor(sec / 60)
    sec %= 60

    // 表示用にゼロパディングをかける
    const hourView = String(hour).padStart(2, '0')
    const minuteView = String(minute).padStart(2, '0')
    const secView = String(sec).padStart(2, '0')

    return hourView + ':' + minuteView + ':' + secView
  }

  //   #####   ##   ##    ###
  //  ##   ##  ##   ##   ## ##
  //  ##   ##  ##   ##  ##   ##
  //   #####   ##   ##  #######
  //  ##        #####   ##   ##
  // 動画サイズから画質を求める
  function setQuality(item) {
    const text = item.innerText

    // console.log(item)
    // console.log(text)

    if (text === 'auto' || ~text.indexOf('Auto')) {
      // item.innerText = '自動'

      // 削除
      // item.parentNode.removeChild(item)

      item.dataset.quality = 'auto'
      return
    }
    if (text === '4K') {
      return
    }
    if (text === 'undefinedp') {
      // 不明な画質データは消す
      console.log(text)
      item.style.display = 'none'
      return
    }
    const size = parseInt(text, 10)
    if (size >= 2160) {
      item.innerText = '4K'

      item.dataset.quality = '4k'
      // } else if (size >= 1080) {
      //   item.innerText = 'FHD'

      //   item.dataset.quality = 'fhd'
    } else if (size >= 720) {
      item.innerText = 'HD'

      item.dataset.quality = 'hd'
    } else if (size <= 719) {
      item.innerText = 'SD'

      item.dataset.quality = 'sd'
    }

    // item.click()
  }

  function videoQualityButtonFix(videoID) {
    const quaLabel = document.querySelectorAll(
      '.video-' + videoID + ' .vjs-quality-selector .vjs-icon-placeholder,.vjs-menu-item'
    )

    for (const iterator of quaLabel) {
      setQuality(iterator)
    }

    const observeItem = document.querySelector('.video-' + videoID + ' .vjs-quality-selector button')
    if (observeItem) {
      const observer = new MutationObserver((records) => {
        if (records[0].target.tagName !== 'SPAN') {
          return
        }
        setQuality(records[0].target)
      })
      observer.observe(observeItem, {
        // 指定要素の変化を監視
        childList: true, // 子要素の監視
        subtree: true, // 子孫要素の監視
        // attributes: true, // 属性の変化を監視
        // attributeFilter: ['style'], // 監視する属性を限定する場合は指定
        characterData: true, // 文字の監視
      })
    }

    // AUTOを最高画質に差し替える
    // setTimeout(() => {
    //   setAutoMax(videoID) // 最高画質にしつつオート表示にする

    //   setInterval(() => {
    //     const nowQua = player[videoID]['hlsQualitySelector']['_currentQuality']
    //     // console.log(nowQua)

    //     if (nowQua === 'auto') {
    //       setAutoMax(videoID) // 最高画質にしつつオート表示にする
    //     }
    //   }, 1000)
    // }, 100)
  }

  function setAutoMax(videoID) {
    // 最高画質にしつつオート表示にする
    player[videoID]['btnQuaMax'] = document.querySelector('.video-' + videoID + ' .vjs-menu-item:nth-last-child(2)')
    player[videoID]['btnQuaAuto'] = document.querySelector('.video-' + videoID + ' .vjs-menu-item:nth-last-child(1)')
    player[videoID]['btnQuaView'] = document.querySelector(
      '.video-' + videoID + ' .vjs-quality-selector .vjs-icon-placeholder'
    )

    player[videoID]['btnQuaMax'].click() // 最高画質をクリック

    setTimeout(() => {
      // console.log(player[videoID]['btnQuaView'])

      player[videoID]['btnQuaView'].innerHTML = 'AUTO' // 現在表示を修正

      // 選択状態を修正
      player[videoID]['btnQuaMax'].classList.remove('vjs-selected')
      player[videoID]['btnQuaAuto'].classList.add('vjs-selected')
    }, 100)
  }

  //   ##  ##  #####  ##    ##
  //   ## ##   ##      ##  ##
  //   ####    #####    ####
  //   ## ##   ##        ##
  //   ##  ##  #####     ##
  function videoKey(videoID, videoItem) {
    window.addEventListener('keydown', function (e) {
      if (!isVisible(videoItem) && !player[videoID].isFullscreen()) {
        // 動画が非表示
        return
      }
      if (checkInputFocus()) {
        // console.log(e.code)
        // テキスト入力中は無効
        return
      }
      // console.log(e.code)

      if (e.code === 'Space') {
        e.preventDefault() // デフォルトのイベントを除去
        // プレイヤーの再生切り替え
        if (player[videoID].paused()) {
          player[videoID].play()
        } else {
          player[videoID].pause()
        }
      }
    })
  }
  // テキスト入力欄にフォーカスしているか確認する
  function checkInputFocus() {
    // console.log(document.activeElement.tagName)
    return document.activeElement.tagName === 'INPUT' || document.activeElement.tagName === 'TEXTAREA'
  }

  /**
   * そのDOMと親に不可視のスタイルが当たっていないかどうかを判定する
   * @param {element} targetElement DOM
   * @returns
   */
  function isVisible(targetElement) {
    if (targetElement.offsetParent === null) {
      return false
    }

    let target = targetElement
    do {
      const style = getComputedStyle(target)

      if (
        style.display === 'none' ||
        style.visibility !== 'visible' ||
        parseFloat(style.opacity || '') <= 0.0 ||
        parseInt(style.height || '', 10) <= 0 ||
        parseInt(style.width || '', 10) <= 0
      ) {
        // 不可視
        return false
      }

      target = target.parentElement
    } while (target !== null)

    // 可視
    return true
  }

  //  ##   ##   #####   ##   ##  #####  #####
  //  ##   ##  ##   ##  ##   ##  ##     ##  ##
  //  #######  ##   ##  ##   ##  #####  #####
  //  ##   ##  ##   ##   ## ##   ##     ##  ##
  //  ##   ##   #####     ###    #####  ##   ##

  // ホバーメニューの作成
  function CreateSkip(player, videoID) {
    let newElement = `


`

    const Component = videojs.getComponent('Component')
    const result = new Component(player[videoID])
    result.el().innerHTML = newElement
    return result
  }
  //            #####    #####   #####
  //            ##  ##  ##   ##  ##  ##
  //  ########  #####   ##   ##  #####
  //            ##      ##   ##  ##
  //            ##       #####   ##
  // ホバーメニュー展開
  function popHoverMenu(videoItem) {
    const timeout = 1200 // 消滅時間
    let menuTimer
    // 画面ホバーで一定時間メニュー展開
    videoItem.addEventListener('mousemove', function () {
      setTimeout(() => {
        videoItem.classList.add('hover')
        clearTimeout(menuTimer)
        menuTimer = setTimeout(function () {
          videoItem.classList.remove('hover')
        }, timeout)
      }, 50)
    })

    // ボタンが押されたら展開延長
    const hoverBtnList = videoItem.querySelectorAll('button')
    for (const btn of hoverBtnList) {
      btn.addEventListener('click', function () {
        clearTimeout(menuTimer)
        menuTimer = setTimeout(function () {
          videoItem.classList.remove('hover')
        }, timeout)
      })
    }
  }

  //            #####   ##        ###    ##    ##
  //            ##  ##  ##       ## ##    ##  ##
  //  ########  #####   ##      ##   ##    ####
  //            ##      ##      #######     ##
  //            ##      ######  ##   ##     ##
  const playToggle = function (videoID) {
    // 再生と停止を切り替え

    console.log(videoID)

    if (player[videoID].paused()) {
      player[videoID].play()
    } else {
      player[videoID].pause()
    }
  }
  window.playToggle = playToggle

  //             ####  ##  ##  ##  #####
  //            ##     ## ##   ##  ##  ##
  //  ########   ###   ####    ##  #####
  //               ##  ## ##   ##  ##
  //            ####   ##  ##  ##  ##

  const videoSkip = function videoSkip(videoID, sec, pause = false) {
    if (pause) {
      // ポーズを伴う
      player[videoID].pause()
    }
    let newTime = player[videoID].currentTime() + sec
    player[videoID].currentTime(newTime)
  }
  window.videoSkip = videoSkip

  //  #####     ###    #####
  //  ##  ##   ## ##   ##  ##
  //  #####   ##   ##  #####
  //  ##  ##  #######  ##  ##
  //  #####   ##   ##  ##   ##

  // 再生速度ボタン
  function addRateBtn(player, videoID) {
    let newElement = `

  <div id="cover-btn"class="js-coverBtn videoFrontBtn flex vcenter hcenter">

    <button type="button" title="30秒戻る" class="videoFrontBtn__item flex vcenter hcenter" onclick="videoSkip(${videoID},-30)">
      <i class="videoFrontBtn__icon videoFrontBtn__icon--back play-icon icon-video-back-30"></i>
    </button>

    <button type="button" title="10秒戻る" class="videoFrontBtn__item flex vcenter hcenter" onclick="videoSkip(${videoID},-10)">
      <i class="videoFrontBtn__icon videoFrontBtn__icon--back play-icon icon-video-back-10"></i>
    </button>


    <button type="button" title="10秒進む" class="videoFrontBtn__item flex vcenter hcenter" onclick="videoSkip(${videoID},10)">
    <i class="videoFrontBtn__icon videoFrontBtn__icon--back play-icon icon-video-skip-10"></i>
    </button>
    <button type="button" title="30秒進む" class="videoFrontBtn__item flex vcenter hcenter" onclick="videoSkip(${videoID},30)">
    <i class="videoFrontBtn__icon videoFrontBtn__icon--back play-icon icon-video-skip-30"></i>
    </button>

  </div>



<div id="videoSpeed-${videoID}-box" class="videoSpeed notranslate">
    <div id="videoSpeed-${videoID}-list" class="videoSpeed__list">
        <button type="button" class="videoSpeed__btn flex vcenter" value="0.25" onclick="changeRate(this.value,${videoID})">0.25</button>
        <button type="button" class="videoSpeed__btn flex vcenter" value="0.50" onclick="changeRate(this.value,${videoID})">0.50</button>
        <button type="button" class="videoSpeed__btn flex vcenter" value="1.00" onclick="changeRate(this.value,${videoID})">1.00</button>
        <button type="button" class="videoSpeed__btn flex vcenter" value="1.25" onclick="changeRate(this.value,${videoID})">1.25</button>
        <button type="button" class="videoSpeed__btn flex vcenter" value="1.50" onclick="changeRate(this.value,${videoID})">1.50</button>
        <button type="button" class="videoSpeed__btn flex vcenter" value="2.00" onclick="changeRate(this.value,${videoID})">2.00</button>
    </div>
    <button type="button" id="videoSpeed-${videoID}-label" class="js-videoSpeedOpen videoSpeed__btn videoSpeed__btn--label flex vcenter hend" data-video-id="${videoID}">1.00</button>
</div>

`

    const Component = videojs.getComponent('Component')
    const result = new Component(player[videoID])
    result.el().innerHTML = newElement

    return result
  }

  // フルスクリーンチャプター展開ボタン
  function addChapterBtn(player, videoID) {
    let newElement = ''

    const chapterTarget = document.querySelector('.video-' + videoID) // 設置先

    if (chapterTarget.dataset.chapter !== undefined && chapterTarget.dataset.chapter !== '') {
      // チャプター情報があればボタンを生成
      newElement = `
<button type="button" id="videoChapterFull-${videoID}" class="js-chapterOpen js-chapterOpen--${videoID} videoChapterBtn flex vcenter hcenter" data-target=".js-chapterOpen-box--${videoID}">
    チャプターを選択する
    <i class="is-false videoChapterBtn__icon icon-up"></i>
</button>
`
    }
    const Component = videojs.getComponent('Component')
    const result = new Component(player[videoID])
    result.el().innerHTML = newElement

    return result
  }

  window.addEventListener('click', function (e) {
    if (!e.target.classList.contains('js-chapterOpen')) {
      return
    }
    e.target.classList.toggle('active')
    document.querySelector(e.target.dataset.target).classList.toggle('active')
  })

  // hovermenu再生ボタン
  let playButton = document.getElementById('hovermenu-play')
  if (playButton) {
    playButton.addEventListener('click', (event) => {
      if (player.paused()) {
        player.play()
      } else {
        player.pause()
      }
    })
  }

  //  ##  ##     ##  #####   #####
  //  ##  ####   ##  ##     ##   ##
  //  ##  ##  ## ##  #####  ##   ##
  //  ##  ##    ###  ##     ##   ##
  //  ##  ##     ##  ##      #####

  // コントロールバーに画質表示
  function quality(player, videoID) {
    /*html*/
    let newElement = `
<div class="videoSpRight flex vcenter">
  <button id="videoMenuOpen" type="button" title="追加メニュー" class="sp-item videoMenu flex vcenter hcenter">
    <i class="is-false videoMenu__icon icon-movie-menu"></i>
  </button>
</div>
`
    const Component = videojs.getComponent('Component')
    const result = new Component(player[videoID])
    result.el().innerHTML = newElement
    return result
  }

  //    ####  #####   #####  #####  ####
  //   ##     ##  ##  ##     ##     ##  ##
  //    ###   #####   #####  #####  ##  ##
  //      ##  ##      ##     ##     ##  ##
  //   ####   ##      #####  #####  ####

  const changeRate = function (rate, videoID) {
    // 速度を取得して反映
    document.getElementById('videoSpeed-' + videoID + '-label').innerText = rate

    player[videoID].playbackRate(rate)

    // 速度メニューのホバー判定を消す
    document.getElementById('videoSpeed-' + videoID + '-list').style.display = 'none'
    setTimeout(() => {
      document.getElementById('videoSpeed-' + videoID + '-list').style.display = ''
    }, 500)
    document.getElementById('videoSpeed-' + videoID + '-box').classList.remove('hover')
  }
  window.changeRate = changeRate

  window.addEventListener('click', function (e) {
    if (!e.target.classList.contains('js-videoSpeedOpen')) {
      return
    }
    const videoID = e.target.dataset.videoId
    document.getElementById('videoSpeed-' + videoID + '-box').classList.add('hover')
  })

  //   ####  ##   ##    ###    #####   ######  #####  #####
  //  ##     ##   ##   ## ##   ##  ##    ##    ##     ##  ##
  //  ##     #######  ##   ##  #####     ##    #####  #####
  //  ##     ##   ##  #######  ##        ##    ##     ##  ##
  //   ####  ##   ##  ##   ##  ##        ##    #####  ##   ##
  function addChapter(videoID, chapter) {
    // スライダー枠を設置する
    const chapterTarget = document.querySelector('.video-' + videoID).parentNode // 設置先

    // ビデオ下のセクション
    const chapterBlock = document.createElement('div')
    chapterBlock.setAttribute('class', 'chapterSlide')

    chapterTarget.parentNode.insertBefore(chapterBlock, chapterTarget.nextSibling) // 要素の直後に追加

    // フルスクリーン時のUI
    const chapterBlockFull = document.createElement('div')
    chapterBlockFull.setAttribute('class', 'js-chapterOpen-box--' + videoID + ' chapterSlide chapterSlide--full')
    chapterTarget.querySelector('.vjs-control-bar').appendChild(chapterBlockFull) // 最後の子要素として追加

    // スライダーを生成する
    let html = ''
    html += `
<div class="chapterSlide__box">
    <div class="js-chapter-${videoID} swiper-container">
        <div class="swiper-wrapper">
`

    const json = JSON.parse(chapter) // テキストをJSONにパース
    let count = 0
    for (const key in json) {
      if (!json.hasOwnProperty(key)) {
        continue
      }
      ++count
      const no = String(count).padStart(2, '0')
      const time = sec2hms(json[key]['sec'])

      html += `
            <div class="swiper-slide flex">
              <button type="button" class="js-chapter flex chapterSlide__item" value="${json[key]['sec']}" data-target="${videoID}">
                  <div class="is-false">
                      <div class="chapterSlide__img">
                          <div class="md-lay zoom block">
                              <div class="lay-bg">
                                  <img src="${json[key]['img']}" alt="チャプター${count}" width="150">
                              </div>
                          </div>
                      </div>
                      <div class="chapterSlide__data">
                          <div class="chapterSlide__time">
                              ${time}
                          </div>
                          <div class="chapterSlide__title">
                             ${json[key]['text']}
                          </div>
                      </div>
                  </div>
              </button>
            </div>
`
      console.log(key + ': ' + json[key])
    }
    html += `

        </div>
    </div>
    <button type="button" class="chapterSlide__move chapterSlide__move--prev swiper-button-prev--chapter-${videoID} flex vcenter hcenter">
      <i class="icon-left"></i>
    </button>
    <button type="button" class="chapterSlide__move chapterSlide__move--next swiper-button-next--chapter-${videoID} flex vcenter hcenter">
      <i class="icon-right"></i>
    </button>
</div>
`
    chapterBlock.innerHTML = html
    chapterBlockFull.innerHTML = html

    const slideItem = document.getElementsByClassName('js-chapter-' + videoID)

    if (slideItem[0]) {
      // Swiperコンテナを検出したら実行
      // eslint-disable-next-line no-unused-vars

      const sliderName = 'chapter-' + videoID
      const chapterSwiper = new Swiper('.js-chapter-' + videoID, {
        effect: 'slide', // slide,fade,cube,coverflow
        speed: 500, // アニメ速度
        slidesPerView: 'auto', //表示数変更 小数指定可　'auto' + .swiper-slide{width:auto;}で可変化
        navigation: {
          nextEl: '.swiper-button-next--' + sliderName, // 前のページボタンを呼び出す要素
          prevEl: '.swiper-button-prev--' + sliderName, // 次のページボタンを呼び出す要素
        },
      })
    }
  }

  // チャプター移動
  window.addEventListener('click', function (e) {
    if (!e.target.classList.contains('js-chapter')) {
      return
    }

    const target = e.target.dataset.target // 対象のビデオID

    // フルスクリーン用UIを閉じる
    document.querySelector('.js-chapterOpen--' + target).classList.remove('active')
    document.querySelector('.js-chapterOpen-box--' + target).classList.remove('active')

    // チャプター移動して再生開始
    const sec = e.target.value
    player[target].currentTime(sec)
    player[target].play()
  })

  /*
秒数をhh:mm:ss形式に直す
*/
  function sec2hms(sec) {
    const hours = Math.floor(sec / 3600)
    const minutes = Math.floor((sec % 3600) / 60)
    const remainingSeconds = Math.floor(sec % 60)

    // 2桁表示にフォーマットするための補完
    function pad(number) {
      return String(number).padStart(2, '0')
    }

    return pad(hours) + ':' + pad(minutes) + ':' + pad(remainingSeconds)
  }

  //  #####   ######  ##     ##             ####   #####   #####    ######
  //  ##  ##    ##    ####   ##            ##     ##   ##  ##  ##     ##
  //  #####     ##    ##  ## ##  ########   ###   ##   ##  #####      ##
  //  ##  ##    ##    ##    ###               ##  ##   ##  ##  ##     ##
  //  #####     ##    ##     ##            ####    #####   ##   ##    ##

  function barBtnSort(videoID) {
    const video = document.querySelector('.video-' + videoID) // 設置先

    // チャプター→画質→速度の順になるよう配置し直す
    const chapterBtn = video.querySelector('#videoChapterFull-' + videoID)
    const cuaBtn = video.querySelector('.vjs-quality-selector')
    const rateBtn = video.querySelector('#videoSpeed-' + videoID + '-box')
    const volumeBtn = video.querySelector('.vjs-volume-panel')

    // セパレーター
    const sep = video.querySelector('.vjs-spacer')

    // ホバーメニュー右上
    const hoverMenuRightTop = video.querySelector('#hoverMenu-rightTop')

    if (cuaBtn) {
      sep.parentNode.insertBefore(cuaBtn, sep.nextSibling) // 要素の直後に追加
    }
    if (rateBtn) {
      sep.parentNode.insertBefore(rateBtn, sep.nextSibling) // 要素の直後に追加
    }

    if (chapterBtn) {
      sep.parentNode.insertBefore(chapterBtn, sep.nextSibling) // 要素の直後に追加
    }
    if (volumeBtn) {
      sep.parentNode.insertBefore(volumeBtn, sep.nextSibling) // 要素の直後に追加
    }
  }

  //    ###     ####  ######  ##   #####   ##     ##
  //   ## ##   ##       ##    ##  ##   ##  ####   ##
  //  ##   ##  ##       ##    ##  ##   ##  ##  ## ##
  //  #######  ##       ##    ##  ##   ##  ##    ###
  //  ##   ##   ####    ##    ##   #####   ##     ##
  //            #####     ###    ##   ##   ####  #####
  //            ##  ##   ## ##   ##   ##  ##     ##
  //  ########  #####   ##   ##  ##   ##   ###   #####
  //            ##      #######  ##   ##     ##  ##
  //            ##      ##   ##   #####   ####   #####

  // すべての動画オブジェクトを止める
  function allPause() {
    for (const iterator of player) {
      if (!iterator) {
        continue
      }
      iterator.pause()
    }
  }

  //             ####  ##   ##    ###    ##     ##   ####    #####
  //            ##     ##   ##   ## ##   ####   ##  ##       ##
  //  ########  ##     #######  ##   ##  ##  ## ##  ##  ###  #####
  //            ##     ##   ##  #######  ##    ###  ##   ##  ##
  //             ####  ##   ##  ##   ##  ##     ##   ####    #####
  // 再生する動画を切り替える
  window.addEventListener('click', function (e) {
    if (!e.target.classList.contains('js-videoChange')) {
      return
    }
    allPause()
    const target = e.target.dataset.videoChange
    const videoID = document.querySelector('.js-videoChange--' + target + ' .js-video').dataset.videoId

    // console.log(videoID)
    player[videoID].play()
  })
  //            #####   ##        ###    ##    ##
  //            ##  ##  ##       ## ##    ##  ##
  //  ########  #####   ##      ##   ##    ####
  //            ##      ##      #######     ##
  //            ##      ######  ##   ##     ##
  // .active配下の動画を再生する
  window.addEventListener('click', function (e) {
    if (!e.target.classList.contains('js-videoActivePlay')) {
      return
    }
    allPause()
    const target = e.target.dataset.videoActivePlay
    const videoID = document.querySelector('.js-videoActivePlay--' + target + ' .active .js-video').dataset.videoId

    player[videoID].play()

    const multiBtn = document.querySelector('.js-videoActivePlay-multi-' + videoID)
    if (multiBtn) {
      // 複数動画の再生ボタンがあったら.activeを付ける
      multiBtn.classList.add('active')
    }
  })

  window.addEventListener('touchstart', function (e) {
    if (e.target.tagName === 'VIDEO') {
      const videoID = e.target.dataset.videoId

      if (player[videoID].paused()) {
        player[videoID].play()
      } else {
        player[videoID].pause()
      }
    }
  })

  //  ###    ###   #####   ####      ###    ##
  //  ## #  # ##  ##   ##  ##  ##   ## ##   ##
  //  ##  ##  ##  ##   ##  ##  ##  ##   ##  ##
  //  ##      ##  ##   ##  ##  ##  #######  ##
  //  ##      ##   #####   ####    ##   ##  ######
  // モーダル開閉時に動画を止める
  window.addEventListener('click', function (e) {
    // 指定のクラスを持つ
    if (e.target.classList.contains('js-modal-open') || e.target.classList.contains('js-modal-close')) {
      allPause()
    }
  })
}

//   ####  ######  ##    ##  ##      #####
//  ##       ##     ##  ##   ##      ##
//   ###     ##      ####    ##      #####
//     ##    ##       ##     ##      ##
//  ####     ##       ##     ######  #####
if (isOS === 'ios') {
  addStyleTag(`
.vjs-volume-panel {
  width: 3em !important;
}
.vjs-volume-control{
 display:none!important;
}
 `)
}

/*
  // スタイルタグを追加する
addStyleTag(`body{
  background:#fff;
}`)
  */

function addStyleTag(css = ``) {
  // styleタグを作成
  const styleTag = document.createElement('style')
  // styleタグに記載するcssを記入
  styleTag.innerText = css
  // 作成したstyleタグを挿入
  document.getElementsByTagName('head')[0].insertAdjacentElement('beforeend', styleTag)
}
